import React from "react";
import { ShieldAlert, ShieldCheck, Shield, Ban, Flag, Hourglass } from "lucide-react";

export function RiskBadge({ level, score }) {
  const tone =
    level === "high"
      ? "bg-red-50 border-red-300 text-red-700"
      : level === "medium"
      ? "bg-amber-50 border-amber-300 text-amber-800"
      : "bg-emerald-50 border-emerald-300 text-emerald-700";
  const Icon = level === "high" ? ShieldAlert : level === "medium" ? Shield : ShieldCheck;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider border ${tone}`}
      title={typeof score === "number" ? `Risk score: ${score}/100` : ""}
      data-testid={`risk-badge-${level || "unknown"}`}
    >
      <Icon className="w-3 h-3" />
      {level || "unknown"}{typeof score === "number" ? ` · ${score}` : ""}
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: { tone: "bg-amber-50 border-amber-300 text-amber-800", Icon: Hourglass },
    verified: { tone: "bg-emerald-50 border-emerald-300 text-emerald-700", Icon: ShieldCheck },
    rejected: { tone: "bg-red-50 border-red-300 text-red-700", Icon: Ban },
  };
  const cfg = map[status] || map.pending;
  const { Icon, tone } = cfg;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold uppercase border ${tone}`} data-testid={`status-${status}`}>
      <Icon className="w-3 h-3" />{status}
    </span>
  );
}

export function FlagPill({ kind }) {
  if (kind === "blacklisted") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold uppercase bg-red-600 text-white" data-testid="flag-blacklisted">
        <Ban className="w-3 h-3" /> Blacklisted
      </span>
    );
  }
  if (kind === "flagged") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold uppercase bg-amber-500 text-white" data-testid="flag-high-risk">
        <Flag className="w-3 h-3" /> High Risk
      </span>
    );
  }
  return null;
}
